import { Slide } from "react-reveal";

const Rewards = () => {
    let rewardsData = [
        { days: '7', subDate: 'Days', bodyText: <p>$5,000 raffle giveaway</p> },
        { days: '14', subDate: 'Days', bodyText: <p>$10,000 raffle giveaway + real life NFT copy</p> },
        { days: '21', subDate: 'Days', bodyText: <p>$20,000 raffle giveaway + FREE 1 of 1 Metamask NFT</p> },
        { days: '28', subDate: 'Days', bodyText: <p>$40,000 raffle giveaway!</p> },
        { days: '2', subDate: 'Months', bodyText: <p>HUGE PRIZE TO BE ANNOUNCED</p> },
    ]
    return (
        <section id="rewards">
            <div className="container">
                <div className="sec-heading-wrapper">
                    <Slide bottom><h1 className="sec-heading">Rewards</h1></Slide>
                    <Slide bottom><h4 className="">COMMENCES AFTER SELLOUT</h4></Slide>
                </div>
                <div className="row rewards_row">
                    {rewardsData.map((rewardItem, index) => (
                        <Slide key={index} bottom>
                            <div className="rewards_box">
                                Holding for
                                <div className="reward_date_box">
                                    <h3>{rewardItem.days}</h3>
                                    <span>{rewardItem.subDate}</span>
                                </div>
                                {rewardItem.bodyText}
                            </div>
                         </Slide>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Rewards
